import { CreateEventDto, UpdateEventDto } from "../../sdk"
import {
  EventDto,
  EventsActionType,
  EventsActionTypes,
} from './types'

export const getEventsRequest = (): EventsActionType => ({
  type: EventsActionTypes.GET_EVENTS_REQUEST,
})

export const getEventsSuccess = (response: EventDto[]): EventsActionType => ({
  type: EventsActionTypes.GET_EVENTS_SUCCESS,
  response,
})

export const getEventsFailure = (errorMsg: string): EventsActionType => ({
  type: EventsActionTypes.GET_EVENTS_FAILURE,
  errorMsg,
})

export const createEventRequest = (data: CreateEventDto): EventsActionType => ({
  type: EventsActionTypes.CREATE_EVENT_REQUEST,
  data,
})

export const createEventSuccess = (response: EventDto): EventsActionType => ({
  type: EventsActionTypes.CREATE_EVENT_SUCCESS,
  response,
})

export const createEventFailure = (errorMsg: string): EventsActionType => ({
  type: EventsActionTypes.CREATE_EVENT_FAILURE,
  errorMsg,
})

export const updateEventRequest = (id: string, data: UpdateEventDto): EventsActionType => ({
  type: EventsActionTypes.UPDATE_EVENT_REQUEST,
  id,
  data,
})

export const updateEventSuccess = (response: EventDto): EventsActionType => ({
  type: EventsActionTypes.UPDATE_EVENT_SUCCESS,
  response,
})

export const updateEventFailure = (errorMsg: string): EventsActionType => ({
  type: EventsActionTypes.UPDATE_EVENT_FAILURE,
  errorMsg,
})

export const deleteEventRequest = (id: string): EventsActionType => ({
  type: EventsActionTypes.DELETE_EVENT_REQUEST,
  id,
})

export const deleteEventSuccess = (): EventsActionType => ({
  type: EventsActionTypes.DELETE_EVENT_SUCCESS,
})

export const deleteEventFailure = (errorMsg: string): EventsActionType => ({
  type: EventsActionTypes.DELETE_EVENT_FAILURE,
  errorMsg,
})
